import api from './api';
import { TOKEN_KEY } from '../utils/constants';
import { clearStoredAuth } from './authSession';

interface UserData {
  name?: string;
  lastName?: string;
  email: string;
  password: string;
  role?: string;
}

export type ClientPlatform = 'web' | 'app';

export interface AuthRequestOptions {
  clientType?: ClientPlatform;
  establishSession?: boolean;
  forceLogoutExisting?: boolean;
  deviceName?: string;
}

export interface ActiveSessionInfo {
  platform: ClientPlatform;
  startedAt: string;
  deviceLabel: string;
}

export interface SessionStatusResponse {
  success: boolean;
  platform: ClientPlatform;
  sessionId: string;
  active: boolean;
}

export const register = async (userData: UserData, options?: AuthRequestOptions) => {
  const response = await api.post('/auth/signup', { ...userData, ...options });
  return response.data;
};

export const login = async (userData: Omit<UserData, 'name'>, options?: AuthRequestOptions) => {
  const response = await api.post('/auth/login', { ...userData, ...options });
  return response.data;
};

export const getMe = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};

export const getSessionStatus = async (): Promise<SessionStatusResponse> => {
  const response = await api.get('/auth/session-status');
  return response.data;
};

export const logout = async () => {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      await api.post('/auth/logout');
    }
  } catch (error) {
    console.warn('Logout request failed, clearing local session anyway.', error);
  } finally {
    clearStoredAuth();
  }
};

export const forgotPassword = async (email: string) => {
  const response = await api.post('/auth/forgot-password', { email });
  return response.data;
};

export const verifyOtp = async (email: string, otp: string) => {
  const response = await api.post('/auth/verify-otp', { email, otp });
  return response.data;
};

export const resetPassword = async (email: string, password: string) => {
  const response = await api.post('/auth/reset-password', { email, password });
  return response.data;
};

// Email verification for registration
export const sendEmailVerificationOtp = async (email: string) => {
  const response = await api.post('/auth/send-email-verification-otp', { email });
  return response.data;
};

export const verifyEmailOtp = async (email: string, otp: string) => {
  const response = await api.post('/auth/verify-email-otp', { email, otp });
  return response.data;
};
